import axios from 'axios';

export async function getIconListList( mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Admin/GetIconsList`);
        return result;
    }
}



export async function getAllHomepageSections( mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Admin/GetHomepageSections`);
        return result;
    }
}

export async function getPublicHomepageSections( mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Public/GetHomepageSections`);
        return result;
    }
}

export async function getHomepageSectionById(id: number | string, mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Admin/GetHomepageSection/${id}`);
        return result;
    }
}

export async function deleteHomepageSectionById(id: number | string, mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Admin/DeleteHomepageSection/${id}`);
        return result;
    }
}

export async function saveHomepageSection(payload:any, mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Admin/SaveHomepageSection`, payload);
        return result;
    }
}

export async function SaveHomepageSectionDisplayOrder(payload:any, mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Admin/SaveHomepageSectionDisplayOrder`, payload);
        return result;
    }
}

